/**
 * @desc 批量全量更新
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.ViewQueryFieldSaveRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/viewQuery/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
